// PRODUCT CARD CLICK EVENT
document.addEventListener('click', function(e) {
  var card = e.target.closest('.card-wrapper.product-card-wrapper');
  if (card) {
    var listSection = card.closest('[data-list-name]');
    Shopify.analytics.publish('darwins:select_item', {
      item_id: card.getAttribute('data-product-id'),
      item_name: card.getAttribute('data-product-title'),
      price: card.getAttribute('data-product-price'),
      item_list_name: listSection
        ? listSection.getAttribute('data-list-name')
        : document.title
    });
  }
});

// PRODUCT LIST VIEW EVENT
var listObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      var section = entry.target;
      var items = [];
      section.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function(card) {
        items.push({
          item_id: card.getAttribute('data-product-id'),
          item_name: card.getAttribute('data-product-title'),
          price: card.getAttribute('data-product-price')
        });
      });
      if (items.length > 0) {
        Shopify.analytics.publish('darwins:view_item_list', {
          item_list_name: section.getAttribute('data-list-name')
            || section.querySelector('h2')?.textContent?.trim(),
          items: items
        });
      }
      listObserver.unobserve(section); // fire once per page load
    }
  });
}, { threshold: 0.5 });

// Observe featured collection sliders and related products sections
document.querySelectorAll('slider-component[data-list-name], product-recommendations[data-list-name]').forEach(function(section) {
  listObserver.observe(section);
});